"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AUTO_ADJUST_BET_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types5.AUTO_ADJUST_BET_TOGGLE;
  }
});
Object.defineProperty(exports, "AUTO_PLAY", {
  enumerable: true,
  get: function get() {
    return _types.AUTO_PLAY;
  }
});
Object.defineProperty(exports, "AUTO_PLAY_BUTTON", {
  enumerable: true,
  get: function get() {
    return _types8.AUTO_PLAY_BUTTON;
  }
});
Object.defineProperty(exports, "AUTO_PLAY_STOP", {
  enumerable: true,
  get: function get() {
    return _types.AUTO_PLAY_STOP;
  }
});
Object.defineProperty(exports, "AckRequest", {
  enumerable: true,
  get: function get() {
    return _AckRequest.AckRequest;
  }
});
Object.defineProperty(exports, "AddCoinsToWinCounter", {
  enumerable: true,
  get: function get() {
    return _actions6.AddCoinsToWinCounter;
  }
});
Object.defineProperty(exports, "AppState", {
  enumerable: true,
  get: function get() {
    return _root.AppState;
  }
});
Object.defineProperty(exports, "BG_LOADING_COMPLETE", {
  enumerable: true,
  get: function get() {
    return _types13.BG_LOADING_COMPLETE;
  }
});
Object.defineProperty(exports, "BLITZ_BUTTON", {
  enumerable: true,
  get: function get() {
    return _types8.BLITZ_BUTTON;
  }
});
Object.defineProperty(exports, "BLITZ_CLOSE_SPLASH", {
  enumerable: true,
  get: function get() {
    return _types3.BLITZ_CLOSE_SPLASH;
  }
});
Object.defineProperty(exports, "BLITZ_FEATURE_COUNT", {
  enumerable: true,
  get: function get() {
    return _types3.BLITZ_FEATURE_COUNT;
  }
});
Object.defineProperty(exports, "BLITZ_FEATURE_SKIP", {
  enumerable: true,
  get: function get() {
    return _types3.BLITZ_FEATURE_SKIP;
  }
});
Object.defineProperty(exports, "BLITZ_FEATURE_STOP_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types3.BLITZ_FEATURE_STOP_TOGGLE;
  }
});
Object.defineProperty(exports, "BLITZ_FLYINGWINS_DISABLE", {
  enumerable: true,
  get: function get() {
    return _types3.BLITZ_FLYINGWINS_DISABLE;
  }
});
Object.defineProperty(exports, "BLITZ_FLYINGWINS_ENABLE", {
  enumerable: true,
  get: function get() {
    return _types3.BLITZ_FLYINGWINS_ENABLE;
  }
});
Object.defineProperty(exports, "BLITZ_PLAY_FEATURE", {
  enumerable: true,
  get: function get() {
    return _types3.BLITZ_PLAY_FEATURE;
  }
});
Object.defineProperty(exports, "BLITZ_SET_ROUNDS", {
  enumerable: true,
  get: function get() {
    return _types3.BLITZ_SET_ROUNDS;
  }
});
Object.defineProperty(exports, "BLITZ_SHOW_SPLASH", {
  enumerable: true,
  get: function get() {
    return _types3.BLITZ_SHOW_SPLASH;
  }
});
Object.defineProperty(exports, "BLITZ_SPLASH_SCREEN_HIDE_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types3.BLITZ_SPLASH_SCREEN_HIDE_TOGGLE;
  }
});
Object.defineProperty(exports, "BLITZ_TOGGLE_BUTTON", {
  enumerable: true,
  get: function get() {
    return _types8.BLITZ_TOGGLE_BUTTON;
  }
});
Object.defineProperty(exports, "BUY_FEATURE", {
  enumerable: true,
  get: function get() {
    return _types9.BUY_FEATURE;
  }
});
Object.defineProperty(exports, "BaseGameController", {
  enumerable: true,
  get: function get() {
    return _BaseGameController.BaseGameController;
  }
});
Object.defineProperty(exports, "BlitzSounds", {
  enumerable: true,
  get: function get() {
    return _types7.BlitzSounds;
  }
});
Object.defineProperty(exports, "COMMAND_PLAY", {
  enumerable: true,
  get: function get() {
    return _types4.COMMAND_PLAY;
  }
});
Object.defineProperty(exports, "COMMAND_QUEUE_NEXT", {
  enumerable: true,
  get: function get() {
    return _types4.COMMAND_QUEUE_NEXT;
  }
});
Object.defineProperty(exports, "CORE", {
  enumerable: true,
  get: function get() {
    return _Core["default"];
  }
});
Object.defineProperty(exports, "CURRENCY_SIGN_HIDE_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types5.CURRENCY_SIGN_HIDE_TOGGLE;
  }
});
Object.defineProperty(exports, "Channel", {
  enumerable: true,
  get: function get() {
    return _Channel.Channel;
  }
});
Object.defineProperty(exports, "CollectRequest", {
  enumerable: true,
  get: function get() {
    return _CollectRequest.CollectRequest;
  }
});
Object.defineProperty(exports, "Collection", {
  enumerable: true,
  get: function get() {
    return _types6.Collection;
  }
});
Object.defineProperty(exports, "CommandType", {
  enumerable: true,
  get: function get() {
    return _CommandType.CommandType;
  }
});
Object.defineProperty(exports, "ConfigState", {
  enumerable: true,
  get: function get() {
    return _types5.ConfigState;
  }
});
Object.defineProperty(exports, "DENOM_MINUS", {
  enumerable: true,
  get: function get() {
    return _types2.DENOM_MINUS;
  }
});
Object.defineProperty(exports, "DENOM_PLUS", {
  enumerable: true,
  get: function get() {
    return _types2.DENOM_PLUS;
  }
});
Object.defineProperty(exports, "DIALOG_EXIT", {
  enumerable: true,
  get: function get() {
    return _types8.DIALOG_EXIT;
  }
});
Object.defineProperty(exports, "DIALOG_NO", {
  enumerable: true,
  get: function get() {
    return _types8.DIALOG_NO;
  }
});
Object.defineProperty(exports, "DIALOG_OK", {
  enumerable: true,
  get: function get() {
    return _types8.DIALOG_OK;
  }
});
Object.defineProperty(exports, "DenomToggle", {
  enumerable: true,
  get: function get() {
    return _actions.DenomToggle;
  }
});
Object.defineProperty(exports, "DialogState", {
  enumerable: true,
  get: function get() {
    return _DialogState.DialogState;
  }
});
Object.defineProperty(exports, "DovazulCommand", {
  enumerable: true,
  get: function get() {
    return _DovazulCommand.DovazulCommand;
  }
});
Object.defineProperty(exports, "EXIT", {
  enumerable: true,
  get: function get() {
    return _types6.EXIT;
  }
});
Object.defineProperty(exports, "EXIT_TO", {
  enumerable: true,
  get: function get() {
    return _types6.EXIT_TO;
  }
});
Object.defineProperty(exports, "ExitReason", {
  enumerable: true,
  get: function get() {
    return _types6.ExitReason;
  }
});
Object.defineProperty(exports, "FAST_PLAY_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types5.FAST_PLAY_TOGGLE;
  }
});
Object.defineProperty(exports, "FeatureAwardType", {
  enumerable: true,
  get: function get() {
    return _FeatureAwardType.FeatureAwardType;
  }
});
Object.defineProperty(exports, "FeatureEndResponse", {
  enumerable: true,
  get: function get() {
    return _FeatureEndResponse.FeatureEndResponse;
  }
});
Object.defineProperty(exports, "FeatureTrigger", {
  enumerable: true,
  get: function get() {
    return _FeatureTrigger.FeatureTrigger;
  }
});
Object.defineProperty(exports, "FeatureWinResponse", {
  enumerable: true,
  get: function get() {
    return _FeatureWinResponse.FeatureWinResponse;
  }
});
Object.defineProperty(exports, "GAME_PLAYER_INPUT", {
  enumerable: true,
  get: function get() {
    return _types6.GAME_PLAYER_INPUT;
  }
});
Object.defineProperty(exports, "GAME_PLAYER_INPUT_WAIT", {
  enumerable: true,
  get: function get() {
    return _types6.GAME_PLAYER_INPUT_WAIT;
  }
});
Object.defineProperty(exports, "GAME_STATUS_SET", {
  enumerable: true,
  get: function get() {
    return _types6.GAME_STATUS_SET;
  }
});
Object.defineProperty(exports, "GAME_WINCOUNTER_ADD", {
  enumerable: true,
  get: function get() {
    return _types6.GAME_WINCOUNTER_ADD;
  }
});
Object.defineProperty(exports, "GameInfoBarState", {
  enumerable: true,
  get: function get() {
    return _types11.GameInfoBarState;
  }
});
Object.defineProperty(exports, "GameSounds", {
  enumerable: true,
  get: function get() {
    return _types7.GameSounds;
  }
});
Object.defineProperty(exports, "GameStatus", {
  enumerable: true,
  get: function get() {
    return _GameStatus.GameStatus;
  }
});
Object.defineProperty(exports, "HIDE_CURRENCY_SIGN_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types5.HIDE_CURRENCY_SIGN_TOGGLE;
  }
});
Object.defineProperty(exports, "HIDE_SPLASH_SCREEN", {
  enumerable: true,
  get: function get() {
    return _types5.HIDE_SPLASH_SCREEN;
  }
});
Object.defineProperty(exports, "HTMLPatternGenerator", {
  enumerable: true,
  get: function get() {
    return _HTMLPatternGenerator.HTMLPatternGenerator;
  }
});
Object.defineProperty(exports, "HTMLPaytable", {
  enumerable: true,
  get: function get() {
    return _HTMLPaytable.HTMLPaytable;
  }
});
Object.defineProperty(exports, "HTMLPaytableMalfunctionMsg", {
  enumerable: true,
  get: function get() {
    return _HTMLPaytableMalfunctionMsg.HTMLPaytableMalfunctionMsg;
  }
});
Object.defineProperty(exports, "HTMLPaytableRTPVolatility", {
  enumerable: true,
  get: function get() {
    return _HTMLPaytableRTPVolatility.HTMLPaytableRTPVolatility;
  }
});
Object.defineProperty(exports, "HTMLPaytableSection", {
  enumerable: true,
  get: function get() {
    return _HTMLPaytableSection.HTMLPaytableSection;
  }
});
Object.defineProperty(exports, "HYPER_SPIN_START", {
  enumerable: true,
  get: function get() {
    return _types6.HYPER_SPIN_START;
  }
});
Object.defineProperty(exports, "HYPER_SPIN_STOP", {
  enumerable: true,
  get: function get() {
    return _types6.HYPER_SPIN_STOP;
  }
});
Object.defineProperty(exports, "IB_STOPPING", {
  enumerable: true,
  get: function get() {
    return _types11.IB_STOPPING;
  }
});
Object.defineProperty(exports, "IGame", {
  enumerable: true,
  get: function get() {
    return _IGame.IGame;
  }
});
Object.defineProperty(exports, "IGameAnimation", {
  enumerable: true,
  get: function get() {
    return _IGameAnimation.IGameAnimation;
  }
});
Object.defineProperty(exports, "IGameComponent", {
  enumerable: true,
  get: function get() {
    return _IGameComponent.IGameComponent;
  }
});
Object.defineProperty(exports, "IGameConstants", {
  enumerable: true,
  get: function get() {
    return _IGameConstants.IGameConstants;
  }
});
Object.defineProperty(exports, "IGameController", {
  enumerable: true,
  get: function get() {
    return _IGameController.IGameController;
  }
});
Object.defineProperty(exports, "IGameEmitter", {
  enumerable: true,
  get: function get() {
    return _IGameEmitter.IGameEmitter;
  }
});
Object.defineProperty(exports, "IGameLoader", {
  enumerable: true,
  get: function get() {
    return _IGameLoader.IGameLoader;
  }
});
Object.defineProperty(exports, "IGameTicker", {
  enumerable: true,
  get: function get() {
    return _IGameTicker.IGameTicker;
  }
});
Object.defineProperty(exports, "L", {
  enumerable: true,
  get: function get() {
    return _logger["default"];
  }
});
Object.defineProperty(exports, "Launcher", {
  enumerable: true,
  get: function get() {
    return _Launcher.Launcher;
  }
});
Object.defineProperty(exports, "MUSIC_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types5.MUSIC_TOGGLE;
  }
});
Object.defineProperty(exports, "Orientation", {
  enumerable: true,
  get: function get() {
    return _Orientation.Orientation;
  }
});
Object.defineProperty(exports, "PRESENTATION_STOP_AVAILABLE", {
  enumerable: true,
  get: function get() {
    return _types6.PRESENTATION_STOP_AVAILABLE;
  }
});
Object.defineProperty(exports, "PRESENTATION_STOP_RESET", {
  enumerable: true,
  get: function get() {
    return _types6.PRESENTATION_STOP_RESET;
  }
});
Object.defineProperty(exports, "PayLineWinResponse", {
  enumerable: true,
  get: function get() {
    return _PayLineWinResponse.PayLineWinResponse;
  }
});
Object.defineProperty(exports, "PayWayWinResponse", {
  enumerable: true,
  get: function get() {
    return _PayWayWinResponse.PayWayWinResponse;
  }
});
Object.defineProperty(exports, "PlayerActionRequest", {
  enumerable: true,
  get: function get() {
    return _PlayerActionRequest.PlayerActionRequest;
  }
});
Object.defineProperty(exports, "PromotionType", {
  enumerable: true,
  get: function get() {
    return _PromotionType.PromotionType;
  }
});
Object.defineProperty(exports, "PromptState", {
  enumerable: true,
  get: function get() {
    return _types8.PromptState;
  }
});
Object.defineProperty(exports, "REELS_STATE_SPINNING", {
  enumerable: true,
  get: function get() {
    return _types6.REELS_STATE_SPINNING;
  }
});
Object.defineProperty(exports, "REELS_STATE_STOPPED", {
  enumerable: true,
  get: function get() {
    return _types6.REELS_STATE_STOPPED;
  }
});
Object.defineProperty(exports, "REELS_STOPPED", {
  enumerable: true,
  get: function get() {
    return _types6.REELS_STOPPED;
  }
});
Object.defineProperty(exports, "REELS_STOPPING", {
  enumerable: true,
  get: function get() {
    return _types6.REELS_STOPPING;
  }
});
Object.defineProperty(exports, "REPLAY_ROUND", {
  enumerable: true,
  get: function get() {
    return _types10.REPLAY_ROUND;
  }
});
Object.defineProperty(exports, "REPLAY_ROUND_DEMO", {
  enumerable: true,
  get: function get() {
    return _types10.REPLAY_ROUND_DEMO;
  }
});
Object.defineProperty(exports, "REQUEST_BET_FEATURE_SET", {
  enumerable: true,
  get: function get() {
    return _types2.REQUEST_BET_FEATURE_SET;
  }
});
Object.defineProperty(exports, "REQUEST_DIALOG_STATE", {
  enumerable: true,
  get: function get() {
    return _types8.REQUEST_DIALOG_STATE;
  }
});
Object.defineProperty(exports, "REQUEST_FEATURE_BUY_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types9.REQUEST_FEATURE_BUY_TOGGLE;
  }
});
Object.defineProperty(exports, "ReelState", {
  enumerable: true,
  get: function get() {
    return _ReelState.ReelState;
  }
});
Object.defineProperty(exports, "RequestBalance", {
  enumerable: true,
  get: function get() {
    return _actions2.RequestBalance;
  }
});
Object.defineProperty(exports, "RoundState", {
  enumerable: true,
  get: function get() {
    return _RoundState.RoundState;
  }
});
Object.defineProperty(exports, "SET_AUTO_PLAY_ROUNDS", {
  enumerable: true,
  get: function get() {
    return _types5.SET_AUTO_PLAY_ROUNDS;
  }
});
Object.defineProperty(exports, "SET_CURRENT_FEATURE_BUY_BY_FEATURE_SET", {
  enumerable: true,
  get: function get() {
    return _types9.SET_CURRENT_FEATURE_BUY_BY_FEATURE_SET;
  }
});
Object.defineProperty(exports, "SET_PROMO_GAME_TEXT", {
  enumerable: true,
  get: function get() {
    return _types8.SET_PROMO_GAME_TEXT;
  }
});
Object.defineProperty(exports, "SHOW_ALL_PAY_LINES", {
  enumerable: true,
  get: function get() {
    return _types8.SHOW_ALL_PAY_LINES;
  }
});
Object.defineProperty(exports, "SOUND_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types5.SOUND_TOGGLE;
  }
});
Object.defineProperty(exports, "SPIN_BUTTON", {
  enumerable: true,
  get: function get() {
    return _types8.SPIN_BUTTON;
  }
});
Object.defineProperty(exports, "SPIN_ON_SPACE_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types5.SPIN_ON_SPACE_TOGGLE;
  }
});
Object.defineProperty(exports, "SPLASH_SCREEN_HIDE_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types3.SPLASH_SCREEN_HIDE_TOGGLE;
  }
});
Object.defineProperty(exports, "ScatterGroups", {
  enumerable: true,
  get: function get() {
    return _IGameConstants.ScatterGroups;
  }
});
Object.defineProperty(exports, "ScreenSize", {
  enumerable: true,
  get: function get() {
    return _types5.ScreenSize;
  }
});
Object.defineProperty(exports, "SendCommand", {
  enumerable: true,
  get: function get() {
    return _actions2.SendCommand;
  }
});
Object.defineProperty(exports, "SetReelsResponse", {
  enumerable: true,
  get: function get() {
    return _SetReelsResponse.SetReelsResponse;
  }
});
Object.defineProperty(exports, "SoundPack", {
  enumerable: true,
  get: function get() {
    return _types7.SoundPack;
  }
});
Object.defineProperty(exports, "StatusText", {
  enumerable: true,
  get: function get() {
    return _types8.StatusText;
  }
});
Object.defineProperty(exports, "StatusTextState", {
  enumerable: true,
  get: function get() {
    return _types8.StatusTextState;
  }
});
Object.defineProperty(exports, "SymbolInfo", {
  enumerable: true,
  get: function get() {
    return _IGameConstants.SymbolInfo;
  }
});
Object.defineProperty(exports, "TOGGLE_DIALOG_STATE", {
  enumerable: true,
  get: function get() {
    return _types8.TOGGLE_DIALOG_STATE;
  }
});
Object.defineProperty(exports, "UPDATE_BALANCE_FORCE", {
  enumerable: true,
  get: function get() {
    return _types12.UPDATE_BALANCE_FORCE;
  }
});
Object.defineProperty(exports, "UPDATE_BET", {
  enumerable: true,
  get: function get() {
    return _types2.UPDATE_BET;
  }
});
Object.defineProperty(exports, "UnfinishedGameResponse", {
  enumerable: true,
  get: function get() {
    return _UnfinishedGameResponse.UnfinishedGameResponse;
  }
});
Object.defineProperty(exports, "UpdateConfig", {
  enumerable: true,
  get: function get() {
    return _actions3.UpdateConfig;
  }
});
Object.defineProperty(exports, "VIBRATE_TOGGLE", {
  enumerable: true,
  get: function get() {
    return _types5.VIBRATE_TOGGLE;
  }
});
Object.defineProperty(exports, "ViewComponent", {
  enumerable: true,
  get: function get() {
    return _ViewComponent.ViewComponent;
  }
});
Object.defineProperty(exports, "coinsToCurrency", {
  enumerable: true,
  get: function get() {
    return _coinsToCurrency.coinsToCurrency;
  }
});
Object.defineProperty(exports, "coinsToNumber", {
  enumerable: true,
  get: function get() {
    return _coinsToNumber.coinsToNumber;
  }
});
Object.defineProperty(exports, "coinsToValue", {
  enumerable: true,
  get: function get() {
    return _coinsToValue.coinsToValue;
  }
});
Object.defineProperty(exports, "createSoundSprite", {
  enumerable: true,
  get: function get() {
    return _actions5.createSoundSprite;
  }
});
Object.defineProperty(exports, "createTween", {
  enumerable: true,
  get: function get() {
    return _createTween.createTween;
  }
});
Object.defineProperty(exports, "currencyFormatter", {
  enumerable: true,
  get: function get() {
    return _currencyFormatter.currencyFormatter;
  }
});
Object.defineProperty(exports, "dateFormatter", {
  enumerable: true,
  get: function get() {
    return _dateFormatter.dateFormatter;
  }
});
Object.defineProperty(exports, "debounce", {
  enumerable: true,
  get: function get() {
    return _debounce.debounce;
  }
});
Object.defineProperty(exports, "debugReelResult", {
  enumerable: true,
  get: function get() {
    return _debugReelResult.debugReelResult;
  }
});
Object.defineProperty(exports, "delayAsync", {
  enumerable: true,
  get: function get() {
    return _delayAsync.delayAsync;
  }
});
Object.defineProperty(exports, "easeInCubic", {
  enumerable: true,
  get: function get() {
    return _Easings.easeInCubic;
  }
});
Object.defineProperty(exports, "easeOutSine", {
  enumerable: true,
  get: function get() {
    return _Easings.easeOutSine;
  }
});
Object.defineProperty(exports, "errorFatal", {
  enumerable: true,
  get: function get() {
    return _errorFatal.errorFatal;
  }
});
Object.defineProperty(exports, "fadeSound", {
  enumerable: true,
  get: function get() {
    return _actions5.fadeSound;
  }
});
Object.defineProperty(exports, "gameAnimationRegistry", {
  enumerable: true,
  get: function get() {
    return _GameAnimationRegistry["default"];
  }
});
Object.defineProperty(exports, "gameComponentRegistry", {
  enumerable: true,
  get: function get() {
    return _GameComponentRegistry["default"];
  }
});
Object.defineProperty(exports, "gameEmitterRegistry", {
  enumerable: true,
  get: function get() {
    return _GameEmitterRegistry["default"];
  }
});
Object.defineProperty(exports, "load", {
  enumerable: true,
  get: function get() {
    return _actions4.load;
  }
});
Object.defineProperty(exports, "loadSoundSprite", {
  enumerable: true,
  get: function get() {
    return _actions4.loadSoundSprite;
  }
});
Object.defineProperty(exports, "loadTranslator", {
  enumerable: true,
  get: function get() {
    return _loadTranslator.loadTranslator;
  }
});
Object.defineProperty(exports, "loopSound", {
  enumerable: true,
  get: function get() {
    return _actions5.loopSound;
  }
});
Object.defineProperty(exports, "numberFormatter", {
  enumerable: true,
  get: function get() {
    return _currencyFormatter.numberFormatter;
  }
});
Object.defineProperty(exports, "platformService", {
  enumerable: true,
  get: function get() {
    return _platformService["default"];
  }
});
Object.defineProperty(exports, "playSound", {
  enumerable: true,
  get: function get() {
    return _actions5.playSound;
  }
});
Object.defineProperty(exports, "preload", {
  enumerable: true,
  get: function get() {
    return _actions4.preload;
  }
});
Object.defineProperty(exports, "preloadStart", {
  enumerable: true,
  get: function get() {
    return _actions4.preloadStart;
  }
});
Object.defineProperty(exports, "raiseSound", {
  enumerable: true,
  get: function get() {
    return _actions5.raiseSound;
  }
});
Object.defineProperty(exports, "randomNumberFromInterval", {
  enumerable: true,
  get: function get() {
    return _randomNumberFromInterval.randomNumberFromInterval;
  }
});
Object.defineProperty(exports, "rateSound", {
  enumerable: true,
  get: function get() {
    return _actions5.rateSound;
  }
});
Object.defineProperty(exports, "reportError", {
  enumerable: true,
  get: function get() {
    return _errorReporter.reportError;
  }
});
Object.defineProperty(exports, "setPlayRate", {
  enumerable: true,
  get: function get() {
    return _actions5.setPlayRate;
  }
});
Object.defineProperty(exports, "setResolution", {
  enumerable: true,
  get: function get() {
    return _actions3.setResolution;
  }
});
Object.defineProperty(exports, "stopSound", {
  enumerable: true,
  get: function get() {
    return _actions5.stopSound;
  }
});
Object.defineProperty(exports, "throttle", {
  enumerable: true,
  get: function get() {
    return _throttle.throttle;
  }
});
Object.defineProperty(exports, "updateBet", {
  enumerable: true,
  get: function get() {
    return _actions.updateBet;
  }
});
var _Channel = require("./dragon/common/enums/Channel");
var _Orientation = require("./dragon/common/enums/Orientation");
var _PromotionType = require("./dragon/common/enums/PromotionType");
var _BaseGameController = require("./dragon/common/interfaces/BaseGameController");
var _CommandType = require("./dragon/dovahzul/CommandType");
var _FeatureWinResponse = require("./dragon/dovahzul/responses/FeatureWinResponse");
var _FeatureEndResponse = require("./dragon/dovahzul/responses/FeatureEndResponse");
var _PayLineWinResponse = require("./dragon/dovahzul/responses/PayLineWinResponse");
var _PayWayWinResponse = require("./dragon/dovahzul/responses/PayWayWinResponse");
var _SetReelsResponse = require("./dragon/dovahzul/responses/SetReelsResponse");
var _types = require("./dragon/store/autoPlay/types");
var _actions = require("./dragon/store/bet/actions");
var _types2 = require("./dragon/store/bet/types");
var _types3 = require("./dragon/store/blitz/types");
var _actions2 = require("./dragon/store/com/actions");
var _types4 = require("./dragon/store/com/types");
var _actions3 = require("./dragon/store/config/actions");
var _types5 = require("./dragon/store/config/types");
var _Core = _interopRequireDefault(require("./dragon/store/Core"));
var _root = require("./dragon/store/root");
var _FeatureAwardType = require("./dragon/store/enums/FeatureAwardType");
var _GameStatus = require("./dragon/store/enums/GameStatus");
var _ReelState = require("./dragon/store/enums/ReelState");
var _RoundState = require("./dragon/store/enums/RoundState");
var _types6 = require("./dragon/store/game/types");
var _actions4 = require("./dragon/store/loader/actions");
var _actions5 = require("./dragon/store/sound/actions");
var _types7 = require("./dragon/store/sound/types");
var _types8 = require("./dragon/store/ui/types");
var _types9 = require("./dragon/store/featureBuy/types");
var _IGame = require("./IGame");
var _IGameController = require("./dragon/common/interfaces/IGameController");
var _Launcher = require("./Launcher");
var _DialogState = require("./ui/enums/DialogState");
var _HTMLPatternGenerator = require("./ui/paytable/HTMLPatternGenerator");
var _HTMLPaytable = require("./ui/paytable/HTMLPaytable");
var _HTMLPaytableMalfunctionMsg = require("./ui/paytable/HTMLPaytableMalfunctionMsg");
var _HTMLPaytableRTPVolatility = require("./ui/paytable/HTMLPaytableRTPVolatility");
var _HTMLPaytableSection = require("./ui/paytable/HTMLPaytableSection");
var _coinsToCurrency = require("./utils/coinsToCurrency");
var _coinsToValue = require("./utils/coinsToValue");
var _coinsToNumber = require("./utils/coinsToNumber");
var _dateFormatter = require("./utils/dateFormatter");
var _currencyFormatter = require("./utils/currencyFormatter");
var _errorFatal = require("./utils/errorFatal");
var _debugReelResult = require("./utils/debugReelResult");
var _errorReporter = require("./utils/errorReporter");
var _loadTranslator = require("./utils/loadTranslator");
var _logger = _interopRequireDefault(require("./utils/logger"));
var _platformService = _interopRequireDefault(require("./utils/platformService"));
var _randomNumberFromInterval = require("./utils/randomNumberFromInterval");
var _throttle = require("./utils/throttle");
var _debounce = require("./utils/debounce");
var _ViewComponent = require("./ViewComponent");
var _IGameComponent = require("./IGameComponent");
var _IGameConstants = require("./IGameConstants");
var _GameComponentRegistry = _interopRequireDefault(require("./GameComponentRegistry"));
var _createTween = require("./tween/createTween");
var _Easings = require("./tween/Easings");
var _DovazulCommand = require("./dragon/dovahzul/DovazulCommand");
var _FeatureTrigger = require("./dragon/common/interfaces/FeatureTrigger");
var _UnfinishedGameResponse = require("./dragon/dovahzul/responses/UnfinishedGameResponse");
var _types10 = require("./dragon/store/replay/types");
var _PlayerActionRequest = require("./dragon/dovahzul/requests/PlayerActionRequest");
var _CollectRequest = require("./dragon/dovahzul/requests/CollectRequest");
var _actions6 = require("./dragon/store/game/actions");
var _delayAsync = require("./utils/delayAsync");
var _AckRequest = require("./dragon/dovahzul/requests/AckRequest");
var _types11 = require("./dragon/store/infoBar/types");
var _types12 = require("./dragon/store/balance/types");
var _GameAnimationRegistry = _interopRequireDefault(require("./GameAnimationRegistry"));
var _IGameAnimation = require("./IGameAnimation");
var _IGameLoader = require("./IGameLoader");
var _IGameTicker = require("./IGameTicker");
var _IGameEmitter = require("./IGameEmitter");
var _GameEmitterRegistry = _interopRequireDefault(require("./GameEmitterRegistry"));
var _types13 = require("./dragon/store/loader/types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//# sourceMappingURL=index.js.map